// ============================================================================
// LA SYNCHRO PÉRIODIQUE OBLIGATOIRE (§13.1quater) — une caisse qui ne se synchronise plus est avertie, puis bloquée.
// Ses délais par défaut et la règle qui les juge, partagés par l'assistant de mise en service et la fiche magasin.
//
// ⚠️ UNE SEULE SOURCE (15 jours puis 30) : l'assistant et la fiche
//    portaient chacun 7 / 14 en dur, et rien ne les obligeait à bouger ensemble.
// ⚠️ Ces délais ne concernent PAS un paiement en retard : celui-ci relève des blocages (J+10, « à venir »).
// ============================================================================

/** Les délais proposés à la mise en service, en jours sans aucune synchronisation réussie. */
export const OFFLINE_RULE_DEFAULTS = { warnDays: '15', lockDays: '30' } as const;

/**
 * Pourquoi ces délais ne peuvent pas être enregistrés — `null` s'ils le peuvent.
 * ⚠️ On REFUSE, on ne corrige pas : un blocage avant l'avertissement bloquerait une caisse jamais prévenue.
 */
export function offlineRuleError(on: boolean, warnDays: string, lockDays: string): string | null {
  if (!on) return null;
  const warn = Number.parseInt(warnDays, 10);
  const lock = Number.parseInt(lockDays, 10);
  if (!(warn > 0) || !(lock > 0)) return 'Indiquez les deux délais, en jours.';
  if (lock <= warn) return 'Le blocage doit venir après l’avertissement : allongez son délai.';
  return null;
}
